import React, { useState } from "react";
import Swal from "sweetalert2";
import about_pattern from "../../assests/about_pattern.svg";
import "./ContactUs.css";
import { submitContactFormCall } from "../../apis/contact-form/repo";
import { SUCCESS } from "../../utils/constants";
import { isInvalidEmail, isOnlyNumber } from "../../utils/validations";
import { isNullOrEmpty } from "../../utils/text-utils";

const swalTheme = {
  background: "#171717",
  color: "#ffffff",
  confirmButtonColor: "#edd569",
  customClass: {
    popup: "contactSwal",
    confirmButton: "contactSwalBtn",
    title: "contactSwalTitle",
  },
};

function ContactUs() {
  const [state, setState] = useState({
    name: "",
    companyName: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  function showPopup({ icon, title, text }) {
    return Swal.fire({
      ...swalTheme,
      icon,
      iconColor: icon === "success" ? "#edd569" : "#e57373",
      title,
      text,
      confirmButtonText: "OK",
    });
  }

  function isViewValid() {
    if (!state.name.trim()) {
      showPopup({
        icon: "warning",
        title: "Name required",
        text: "Please enter your name.",
      });
      return false;
    }
    if (!state.mobile.trim()) {
      showPopup({
        icon: "warning",
        title: "Mobile required",
        text: "Please enter your mobile number.",
      });
      return false;
    }
    if (state.email && isInvalidEmail(state.email)) {
      showPopup({
        icon: "warning",
        title: "Invalid email",
        text: "Please enter a valid email address.",
      });
      return false;
    }
    return true;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isViewValid()) {
      const payload = {
        Name: state.name.trim(),
        Company_Name: state.companyName.trim(),
        Email: state.email.trim(),
        Mobile: state.mobile.trim(),
        Subject: state.subject.trim(),
        Message: state.message.trim(),
      };
      setIsLoading(true);
      submitContactFormCall(payload)
        .then(({ data }) => {
          setIsLoading(false);
          const isFailed =
            (data?.error_code != null && data.error_code !== SUCCESS) ||
            data?.success === false ||
            data?.status === false;
          if (!isFailed) {
            setState({
              name: "",
              companyName: "",
              email: "",
              mobile: "",
              subject: "",
              message: "",
            });
            showPopup({
              icon: "success",
              title: "Thank you!",
              text:
                data?.message ||
                data?.Message ||
                "Your message has been sent. We will contact you shortly.",
            });
          } else {
            showPopup({
              icon: "error",
              title: "Submission failed",
              text:
                data?.message ||
                data?.Message ||
                "Please try again in a moment.",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
          showPopup({
            icon: "error",
            title: "Submission failed",
            text:
              err?.response?.data?.message ||
              err?.response?.data?.Message ||
              "Please try again in a moment.",
          });
        });
    }
  };

  return (
    <div
      id="contact_us"
      style={{
        backgroundImage: `url(${about_pattern})`,
        backgroundSize: "cover",
      }}
      className="w-full bg-[#1E1E1E] md:py-16"
    >
      <div className="w-auto md:w-1/2 m-auto bg-[#171717]">
        <form className="form p-[18px] md:p-[50px]" onSubmit={handleSubmit}>
          <p className="title">Get in Touch</p>
          <div className="flex1">
            <label className="w-1/2">
              <input
                className="input1"
                type="text"
                name="name"
                placeholder=""
                value={state.name}
                onChange={handleChange}
                required
              />
              <span>Name</span>
            </label>

            <label className="w-1/2">
              <input
                className="input1"
                type="text"
                name="companyName"
                placeholder=""
                value={state.companyName}
                onChange={handleChange}
              />
              <span>Company Name</span>
            </label>
          </div>
          <div className="flex1">
            <label className="w-1/2">
              <input
                className="input1"
                type="email"
                name="email"
                placeholder=""
                value={state.email}
                onChange={handleChange}
              />
              <span>Email</span>
            </label>
            <label className="w-1/2">
              <input
                className="input1"
                type="tel"
                name="mobile"
                placeholder=""
                value={state.mobile}
                onChange={(e) => {
                  if (isOnlyNumber(e.target.value) || isNullOrEmpty(e.target.value))
                    setState((prevState) => ({ ...prevState, mobile: e.target.value }));
                }}
                required
              />
              <span>Mobile</span>
            </label>
          </div>
          <label>
            <input
              className="input1"
              type="text"
              name="subject"
              placeholder=""
              value={state.subject}
              onChange={handleChange}
            />
            <span>Subject</span>
          </label>
          <label>
            <textarea
              style={{ resize: "none" }}
              className="input1"
              name="message"
              placeholder=""
              value={state.message}
              onChange={handleChange}
              cols={30}
              rows={7}
            />
            <span>How can we help you</span>
          </label>
          <div className="w-full flex justify-end">
            <button className="submit" disabled={isLoading}>
              {isLoading ? "Processing..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ContactUs;
